



























import { isLoggedIn, LoginView } from "@micad/vue-components";
import { computed, defineComponent, reactive, ref } from "@vue/composition-api";
import { getVersion } from "@/config";
import { initApp } from "@/modules/auth";
import router, { anonymousRoutes } from "@/router";
import { QPage } from "quasar";
import AIAssistant from "@/components/AIAssistant.vue";
import { getClientConfigValue } from "@/data/repos/clientConfig";

const default_layout = "default";
const layout = ref(default_layout + "-layout");

function updateLayout() {
  layout.value =
    (router?.currentRoute?.meta?.layout || default_layout) + "-layout";
}
export default defineComponent({
  components: { LoginView, QPage, AIAssistant },
  watch: {
    $route(to, from) {
      updateLayout();
    },
  },
  setup(props, ctx) {
    const state = reactive({
      appVersion: "",
      loaded: false,
      authenticated: false,
      errorMessage: "",
      routeName: computed(() => ctx.root.$route.name),
      aiAssistantEnabled: false,
    });

    setTimeout(async () => {
      const ok = await initApp();
      console.log("Config OK/Status?:", ok);
      state.appVersion = await getVersion();
      state.loaded = ok;
      if (!ok) {
        state.errorMessage =
          "Application cannot load configuration. Please refresh or contact administrator if error persists. Error code CNF001.";
        console.error(state.errorMessage);
      }
      updateLayout();
      getClientConfigValue("SHOW_AI").then(
        (resp) =>
          (state.aiAssistantEnabled = ["y", "yes", "true"].includes(
            (resp.payload?.value || "").toLocaleLowerCase()
          ))
      );
    });
    return { state, layout, isLoggedIn, anonymousRoutes };
  },
});
